module.exports = __webpack_public_path__ + "static/media/Dialogflow_logo.a154f0af.svg";